import { render, staticRenderFns } from "./customerInfoIndex.vue?vue&type=template&id=8e12ecf0&scoped=true"
import script from "./customerInfoIndex.vue?vue&type=script&lang=js"
export * from "./customerInfoIndex.vue?vue&type=script&lang=js"
import style0 from "./customerInfoIndex.vue?vue&type=style&index=0&id=8e12ecf0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e12ecf0",
  null
  
)

export default component.exports